import { RouteConfig, FlatRoute, NavigationItem } from "@/types/navigation.types";
import { UserRole } from "@shared/constants/api";

export const getRoutesForRole = (routes: RouteConfig[], role: UserRole): RouteConfig[] => {
  return routes
    .filter((route) => route.roles.includes(role))
    .map((route) => ({
      ...route,
      children: route.children ? getRoutesForRole(route.children, role) : undefined,
    }));
};

export const flattenRoutes = (routes: RouteConfig[]): FlatRoute[] => {
  const result: FlatRoute[] = [];

  const flatten = (routeList: RouteConfig[]) => {
    for (const route of routeList) {
      result.push({
        path: route.path,
        component: route.component,
        roles: route.roles,
      });

      if (route.children) {
        flatten(route.children);
      }
    }
  };

  flatten(routes);
  return result;
};

export const getSidebarItems = (routes: RouteConfig[], role: UserRole): NavigationItem[] => {
  const authorizedRoutes = getRoutesForRole(routes, role);

  const buildNavItems = (routeList: RouteConfig[]): NavigationItem[] => {
    return routeList
      .filter((route) => route.sidebar && route.sidebar.showInSidebar !== false)
      .map((route) => ({
        path: route.path,
        label: route.sidebar!.label,
        icon: route.sidebar!.icon,
        order: route.sidebar!.order,
        roles: route.roles,
        children: route.children ? buildNavItems(route.children) : undefined,
        comingSoon: route.sidebar!.comingSoon,
      }))
      .filter((item) => item.path || (item.children && item.children.length > 0))
      .sort((a, b) => a.order - b.order);
  };

  return buildNavItems(authorizedRoutes);
};

export const getNavigationItemByPath = (
  items: NavigationItem[],
  pathname: string
): NavigationItem | undefined => {
  for (const item of items) {
    if (item.path && (pathname === item.path || pathname.startsWith(item.path + "/"))) {
      return item;
    }
    if (item.children) {
      const childMatch = item.children.find((child) => child.path && pathname === child.path);
      if (childMatch) return childMatch;
    }
  }
  return undefined;
};
